import React from 'react';
import { Box, Typography, Link, ListItem } from '@mui/material';
import { sxHeader } from './styles';

const MenuItemLink = ({ icon, label, href, onClick, hoverSrc }) => {
  return (
    <ListItem
      onClick={onClick}
      sx={{
        ...sxHeader.itemMenuMobile,
        cursor: href || onClick ? 'pointer' : 'default',
        alignItems: 'center',
      }}
    >
      {/* 👇 Detecta si 'icon' es un string (ruta) o un componente */}
      {typeof icon === 'string' ? (
        <Box
          component="img"
          src={hoverSrc || icon}
          alt=""
          sx={{ width: 24, height: 24, mr: 1 }}
        />
      ) : (
        icon && React.cloneElement(icon, { sx: { mr: 1, fontSize: 24 } })
      )}

      {href ? (
        <Link
          href={href}
          sx={{
            ...sxHeader.itemMenuMobile,
            textDecoration: 'none',
          }}
          target="_blank"
        >
          <Typography sx={sxHeader.itemMenuMobile}>{label}</Typography>
        </Link>
      ) : (
        <Typography sx={sxHeader.itemMenuMobile}>{label}</Typography>
      )}
    </ListItem>
  );
};

export default MenuItemLink;
